import { debounce } from 'lodash'
import { useEffect, useState } from 'react'
import { Toggle } from 'shared/components/Checkbox/Toggle'
import { InlineSpinner } from 'shared/components/Spinner'
import { Text } from 'shared/components/Text/Text'

import { Card, FlexBox } from '../../../components/Base/Base'
import { useUserProvider } from '../../../components/Context/UserContext'
import { isConsole } from '../../../config/config'
import { Team } from '../../../models/team'
import { getTruckListSetting, updateTruckListSetting } from '../../../models/truckList'
import { User } from '../../../models/user'

interface ProfileSettingsProps {
  user: User
  team: Team | null
}

export function ProfileSettings({ user, team }: ProfileSettingsProps) {
  const [loading, setLoading] = useState(true)
  const [truckListEnabled, setTruckListEnabled] = useState(team?.truckListSetting?.isOptedIn)
  const { loggedInUser, permissions } = useUserProvider()
  const saveSettings = (isOptedIn: boolean) => {
    if (user.team) {
      updateTruckListSetting(user.team, isOptedIn).then((data) => setTruckListEnabled(data.isOptedIn))
    }
  }
  const [debouncedSaveSettings] = useState(() => debounce(saveSettings, 300))

  useEffect(() => {
    if (truckListEnabled === undefined && team?.id) {
      getTruckListSetting(team?.id).then((data) => {
        setTruckListEnabled(data.isOptedIn)
      })
    }
    setLoading(false)
  }, [setLoading, truckListEnabled, team?.id])

  if (loading) return <InlineSpinner />

  const isModifyingSelf = loggedInUser?.id === user.id
  const canChangeCustomUser = permissions.canChangeCustomUser
  const canEdit = isConsole() ? canChangeCustomUser : (isModifyingSelf || loggedInUser?.isTeamAdmin) ?? false

  return (
    <Card hasSubtleShadow smallerPadding align="left">
      <FlexBox>
        <FlexBox isColumn>
          <Text variant="header3">Share your availability with brokers</Text>
          <Text variant="paragraph2">
            CloudTrucks will automatically share your availability with brokers, so they can contact you about
            available loads.
          </Text>
        </FlexBox>
        <FlexBox ml={1} alignItems="center">
          <Toggle value={truckListEnabled} onChange={debouncedSaveSettings} disabled={!canEdit} />
        </FlexBox>
      </FlexBox>
    </Card>
  )
}
